const meses = [
  { id: "01", mes: "Enero", dias: 31 },
  { id: "02", mes: "Febrero", dias: 29 },
  { id: "03", mes: "Marzo", dias: 31 },
  { id: "04", mes: "Abril", dias: 30 },
  { id: "05", mes: "Mayo", dias: 31 },
  { id: "06", mes: "Junio", dias: 30 },
  { id: "07", mes: "Julio", dias: 31 },
  { id: "08", mes: "Agosto", dias: 31 },
  { id: "09", mes: "Septiembre", dias: 30 },
  { id: "10", mes: "Octubre", dias: 31 },
  { id: "11", mes: "Noviembre", dias: 30 },
  { id: "12", mes: "Diciembre", dias: 31 }
];

export default {
  meses
};



// WEBPACK FOOTER //
// ./src/assets/js/meses.js